import React, {Component} from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import {Feedback} from './feedback';
import {Title} from './title';
import {TableCell, TextField, withStyles} from '@material-ui/core';
import {styles, Classes} from './styles';
import {Props, State} from './type';
import {MobileStatistic} from '../mobile';
import {BREAKPOINT_MD} from '../services/constans';

type ITableProps = Classes & Props;

class SimpleTable extends Component<ITableProps, State> {
    state = {
        mobile: false
    };

    componentDidMount() {
        // window.addEventListener('resize', this.resize);
        // this.resize();
    }

    componentWillUnmount() {
        // window.removeEventListener('resize', this.resize);
    }

    sortingRating = () => {
        const derection = this.props.derection === 'asc' ? 'desc' : 'asc';
        this.props.sortingRating(derection);
    }

    resize = () => {
        this.setState({mobile: window.innerWidth < BREAKPOINT_MD});
    }

    render() {
        const {classes, data} = this.props;

        return (
            <>
                {this.state.mobile
                    ?
                    <MobileStatistic
                        data={data}
                        filterAuthor={this.props.filterAuthor}
                        filterUser={this.props.filterUser}
                        authorFilter={this.props.authorFilter}
                        recipientFilter={this.props.recipientFilter}
                        sortingRating={this.sortingRating}
                        derection={this.props.derection}
                    />
                    :
                    <Paper>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.defaultColumnWidth}>
                                        <TextField
                                            label="Author"
                                            fullWidth={true}
                                            value={this.props.authorFilter}
                                            onChange={this.props.filterAuthor}
                                            InputProps={{
                                                endAdornment: (
                                                    <SearchIcon/>
                                                )
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.defaultColumnWidth}>
                                        <TextField
                                            label="Recipient"
                                            fullWidth={true}
                                            value={this.props.recipientFilter}
                                            onChange={this.props.filterUser}
                                            InputProps={{
                                                endAdornment: (
                                                    <SearchIcon/>
                                                )
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.defaultColumnWidth}>
                                        <TextField
                                            label="Team"
                                            fullWidth={true}
                                            value={this.props.recipientTeamFilter}
                                            onChange={this.props.filterTeam}
                                            InputProps={{
                                                endAdornment: (
                                                    <SearchIcon/>
                                                )
                                            }}
                                        />
                                    </TableCell>
                                    <Title
                                        orderBy={this.props.derection}
                                        handleClick={this.sortingRating}
                                    />
                                    <TableCell className={this.props.data.length
                                        ? classes.reset
                                        : classes.notFount}>Comments
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    data.length > 0
                                        ? data.map(feedback => (
                                            <TableRow
                                                hover={true}
                                                key={feedback.feedbackId}
                                                className={classes.defaultCard}>
                                                <Feedback
                                                    author={`${feedback.author.firstName} ${feedback.author.lastName}`}
                                                    name={feedback.recipient}
                                                    team={feedback.recipientTeam}
                                                    rating={feedback.feedbackData.RATING}
                                                    id={feedback.feedbackId}
                                                    comment={feedback.feedbackData.COMMENT}
                                                />
                                            </TableRow>)
                                        ) : <TableRow>
                                            <TableCell>Not Found</TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </Paper>
                }
            </>
        );
    }
}

export default withStyles(styles)(SimpleTable);
